export default __webpack_public_path__ + "static/media/car.c42f8934.svg";